import { FC, useContext, useEffect } from "react";
import { Box } from "@material-ui/core";
import { usePostHog } from "posthog-js/react";

import { Button } from "components";
import { AppContext } from "contexts";
import { getCookie, navigateTo } from "lib/helpers";
import * as routes from "routes";
import { getPageURL } from "routes/config";
import { MenuItem, MenuItems } from "services/app/types";
import { mobileHeaderHeight } from "theme/constants";

import HeaderItem from "./HeaderItem";

interface MobileHeaderProps {
  menuItems: MenuItems;
  isLoggedIn: boolean;
  linkLogin: string;
  linkLogout: string;
  linkSignUp: string;
  hidden: boolean;
}

const MobileHeader: FC<MobileHeaderProps> = ({
  menuItems,
  isLoggedIn,
  linkLogin,
  linkLogout,
  linkSignUp,
  hidden,
}) => {
  const { domainNames, user } = useContext(AppContext);
  const posthog = usePostHog();
  const csrfToken = getCookie("csrftoken");

  const openSideBar = () => document.body.classList.add("-nav-open");
  const closeSideBar = () => document.body.classList.remove("-nav-open");

  useEffect(() => {
    return closeSideBar;
  }, []);

  return (
    <>
      <nav
        className={`navigation es-nav-mobile${hidden ? "" : " -open"}`}
        style={{
          transform: `translate3d(0px, ${
            hidden ? `-${mobileHeaderHeight}px` : "0px"
          }, 0px)`,
        }}
      >
        <div className="-container">
          <a href="/" className="-logo">
            {" "}
          </a>
          <div id="nav-toggle" onClick={openSideBar}>
            <div className="-icon">
              <span></span>
            </div>
          </div>
        </div>
      </nav>
      <div className="-mobile-links">
        <div className="-heading">
          <div id="close-nav" className="-active" onClick={closeSideBar}>
            <div className="-icon">
              <span></span>
            </div>
          </div>
        </div>
        <div className="-links-container">
          <ul>
            {menuItems &&
              menuItems.topnav.map((menuItem: MenuItem, index: number) => (
                <HeaderItem
                  key={`${index}-${menuItem.name}`}
                  menuItem={menuItem}
                />
              ))}
            {isLoggedIn && (
              <>
                <li>
                  <a
                    href={getPageURL(
                      routes.orderBookBuyerDashboard(),
                      domainNames,
                    )}
                    className="text -nav -dark"
                    id="id_dashboard_button"
                  >
                    Buyer Dashboard
                  </a>
                </li>
                <li>
                  <a
                    href={getPageURL(routes.sellerDashboard(), domainNames)}
                    className="text -nav -dark"
                    id="id_instant_valuation_button"
                  >
                    My Royalties
                  </a>
                </li>
                <li>
                  <a
                    href={getPageURL(
                      routes.orderBookOpenListings(user.userId),
                      domainNames,
                    )}
                    className="text -nav -dark"
                    id="id_live_orderbook_button"
                  >
                    The Exchange
                  </a>
                </li>
                <li>
                  <a
                    href={getPageURL(routes.directoryProfile(), domainNames)}
                    className="text -nav -dark"
                    id="id_profile_button"
                  >
                    Edit Profile
                  </a>
                </li>
                <li>
                  <form method="post" action={linkLogout}>
                    <input
                      type="hidden"
                      name="csrfmiddlewaretoken"
                      value={csrfToken}
                    />
                    <button
                      id="id_signout_button_mobile"
                      className="text -nav -dark"
                      type="submit"
                      onClick={() => posthog?.reset()}
                    >
                      Log Out
                    </button>
                  </form>
                </li>
              </>
            )}
            {!isLoggedIn && (
              <li>
                <a href={linkLogin} className="text -nav -dark">
                  Sign In
                </a>
              </li>
            )}
          </ul>
          {!isLoggedIn && (
            <Box
              style={{
                margin: "8px auto",
                width: "82%",
              }}
            >
              <Button
                variant="contained"
                onClick={() => navigateTo(linkSignUp)}
                fullWidth
                style={{
                  fontSize: "1rem",
                }}
              >
                Join Now
              </Button>
            </Box>
          )}
        </div>
      </div>
    </>
  );
};

export default MobileHeader;
